/**
 * Missing-Retention rule for Premium Selection (OR-1733).
 *
 * A blank Retention means the broker hasn't sent one yet, so the facility has
 * no SIR credit and its SIR-adjusted premium is never calculated. The backend
 * sums only the facilities that have one, so Premium w/ SIR Credit, Adjusted
 * Premium and Total Premium come back as $0 or a partial sum. Underwriting's
 * call: never price a blank as $0 (an explicit $0 is a real retention) —
 * warn instead and hide those values until every covered facility has one.
 */
import type { PremiumSelectionDerived } from "../../../domain/pricing/premium-selection";
import type { Facility } from "../../../types/facility";

/** Covered (not archived) facilities whose Retention is blank. "0" counts as set. */
export function countMissingRetention(facilities: Facility[]): number {
    return facilities.filter((f) => !f.isExcluded && !f.retention?.trim()).length;
}

/** The values built on the partial SIR sum, blanked ("—") while any Retention is missing. */
export function hidePartialSirValues(derived: PremiumSelectionDerived | null, hide: boolean): PremiumSelectionDerived | null {
    if (!hide || derived === null) return derived;
    return { ...derived, premiumWithSirCredit: null, adjustedPremium: null, totalPremium: null };
}
